interface AboutCompanyTwoItemProps {
  title: string;
  secondaryText: string;
}

const AboutCompanyTwoItem = ({ title, secondaryText }: AboutCompanyTwoItemProps) => {
  return (
    <div className="w-full max-w-[400px] flex flex-col items-start justify-start p-6">
      <hr className="w-full h-[0.50px] border-white max-w-[400px]" />
      <div className="text-white text-4xl font-normal font-['Forum'] uppercase mt-2 text-[48px] lg:text-[86px] leading-[40px] lg:leading-[86px]">
        {title}
      </div>
      <div className="text-neutral-50 text-lg font-light font-['Inter'] text-[20px] lg:text-[24px]">
        {secondaryText}
      </div>
    </div>
  );
};

export default AboutCompanyTwoItem;

